module.exports = __webpack_public_path__ + "img/culture-small.615866fb.jpg";